/**
 * AppStateZustand bond setup
 *
 * Wires @molecule/app-state-zustand to @molecule/app-state
 */

import { setProvider } from '@molecule/app-state'
import { provider } from '@molecule/app-state-zustand'

export function setupAppStateZustand(): void {
  setProvider(provider)
}
